import React from "react";
import ReactDOM from "react-dom";
import Chart from "react-google-charts";
import Loader from '../../components/common/LoaderMask';

export default class BarChart extends React.Component {

    constructor(props){
        super(props)
    }

    componentDidMount(){
       // console.log("this.props.params ",this.props.params);
    }


    getChart(){
        var params = this.props.params;
        return (
            <Chart chartType={params.chartType || "BarChart"} width={params.width || '500px'}
            height={params.height || '300px'}
            loader={Loader}
            data={params.data || []}
            options={{
                title: params.options.title || '',
                chartArea: params.options.chartArea || {width:'50%'},
                legend: params.options.legend ||  { position: 'none' },
                isStacked: params.options.isStacked || true,
                bar: params.options.bar || { groupWidth: '90%' },
                hAxis: params.options.hAxis || {
                    title: 'Percentile Ranking',
                    minValue: 0
                  },
                vAxis: params.options.vAxis || {
                  title: '',
                },
                tooltip:{ trigger: 'none' },
                crosshair: { trigger: 'none' }
              }}
            />
        )
    }

  render() {
    return (
      <div className="BarChart">
        {this.getChart()}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/vendors/mindstretcher/BarChart.js